import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import AuthLayout, { AuthLink, ErrorBox, Field, SubmitButton, inputClass } from '../components/auth/AuthLayout'
import { resetPassword, errorText } from '../api/auth'
import useDocumentTitle from '../hooks/useDocumentTitle'

/** Strona pod linkiem z maila resetującego: /nowe-haslo/:key */
const PasswordResetConfirm = () => {
  useDocumentTitle('Ustaw nowe hasło')
  const { key } = useParams()
  const navigate = useNavigate()

  const [form, setForm] = useState({ password: '', password2: '' })
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    if (form.password !== form.password2) {
      setError('Hasła nie są takie same.')
      return
    }
    setBusy(true)
    const res = await resetPassword({ key, password: form.password })
    setBusy(false)

    if (res.errors && res.errors.length) {
      setError(errorText(res, 'Nie udało się ustawić nowego hasła.'))
      return
    }
    setDone(true)
    setTimeout(() => navigate('/logowanie', { replace: true }), 3000)
  }

  if (done) {
    return (
      <AuthLayout title="Hasło zmienione" subtitle="Możesz się teraz zalogować nowym hasłem.">
        <div className="flex justify-center py-4">
          <CheckCircleIcon className="w-14 h-14 text-emerald-500" />
        </div>
        <div className="text-center text-sm"><AuthLink to="/logowanie">Przejdź do logowania</AuthLink></div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title="Ustaw nowe hasło"
      footer={<AuthLink to="/logowanie">Wróć do logowania</AuthLink>}
    >
      <form onSubmit={submit} noValidate>
        <ErrorBox>{error}</ErrorBox>
        <Field label="Nowe hasło" hint="Co najmniej 8 znaków. Unikaj popularnych haseł.">
          <input type="password" required autoComplete="new-password" className={inputClass}
                 value={form.password} onChange={set('password')} disabled={busy} />
        </Field>
        <Field label="Powtórz nowe hasło">
          <input type="password" required autoComplete="new-password" className={inputClass}
                 value={form.password2} onChange={set('password2')} disabled={busy} />
        </Field>
        <SubmitButton busy={busy}>Zapisz nowe hasło</SubmitButton>
      </form>
    </AuthLayout>
  )
}

export default PasswordResetConfirm
